export const PUBLIC_SITE_A11Y_STORAGE_KEY = "hr_public_site_a11y_v1";
export const PUBLIC_SITE_A11Y_ROOT_ATTR = "data-hr-public-site-a11y";

export const TEXT_SCALE_OPTIONS = [
  { id: "100", label: "רגיל", multiplier: 1 },
  { id: "110", label: "גדול", multiplier: 1.1 },
  { id: "120", label: "גדול מאוד", multiplier: 1.2 },
];

const DEFAULT_PREFERENCES = {
  textScale: "100",
  highContrast: false,
  underlineLinks: false,
  reduceMotion: false,
};

export function getDefaultPublicSiteA11yPreferences() {
  return { ...DEFAULT_PREFERENCES };
}

export function loadPublicSiteA11yPreferences() {
  if (typeof window === "undefined") return getDefaultPublicSiteA11yPreferences();
  try {
    const raw = window.localStorage.getItem(PUBLIC_SITE_A11Y_STORAGE_KEY);
    if (!raw) return getDefaultPublicSiteA11yPreferences();
    const parsed = JSON.parse(raw);
    return {
      ...DEFAULT_PREFERENCES,
      ...(parsed && typeof parsed === "object" ? parsed : {}),
    };
  } catch {
    return getDefaultPublicSiteA11yPreferences();
  }
}

export function savePublicSiteA11yPreferences(prefs) {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(PUBLIC_SITE_A11Y_STORAGE_KEY, JSON.stringify(prefs));
  } catch {
    /* ignore quota */
  }
}

/**
 * מחיל העדפות על documentElement — רק בזמן שהאתר הציבורי פעיל.
 * @param {ReturnType<typeof getDefaultPublicSiteA11yPreferences>} prefs
 */
export function applyPublicSiteA11yToDocument(prefs) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.setAttribute(PUBLIC_SITE_A11Y_ROOT_ATTR, "");
  root.setAttribute("data-a11y-text-scale", String(prefs.textScale || "100"));
  root.toggleAttribute("data-a11y-high-contrast", Boolean(prefs.highContrast));
  root.toggleAttribute("data-a11y-underline-links", Boolean(prefs.underlineLinks));
  root.toggleAttribute("data-a11y-reduce-motion", Boolean(prefs.reduceMotion));
}

export function clearPublicSiteA11yFromDocument() {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.removeAttribute(PUBLIC_SITE_A11Y_ROOT_ATTR);
  root.removeAttribute("data-a11y-text-scale");
  root.removeAttribute("data-a11y-high-contrast");
  root.removeAttribute("data-a11y-underline-links");
  root.removeAttribute("data-a11y-reduce-motion");
}
